import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ImageCarousel from '../../imageCarousel';

const GalleryPage = () => {

  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('Pages.Gallery.Header');
  }, []);

  return (
    <div className="con-container">
      <div className="con-content">
        <div className="con-flex__container">
          <h1 className="con-heading con-heading__l--margin-bottom-3">{t('Pages.Gallery.Header')}</h1>
        </div>
        <ImageCarousel /> 
      </div>
    </div>
  );
};

export default GalleryPage;